const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts'));
let viewed_products = [];
const productDataElement = document.getElementById('ProductDataJSON');
const productData = productDataElement ? JSON.parse(productDataElement.textContent) : null;

//////////////////////////////////////////////////

function getProductPrice(arrayID) {
    return viewed_products[arrayID].price ? viewed_products[arrayID].price : `${viewed_products[arrayID].price} - ${viewed_products[arrayID].price}`;
}

function formatPrice(price) {
    let convertedPrice = (price / 100.0).toFixed(2);

    let parts = convertedPrice.split('.');
    let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ',');
    let cents = parts[1] && parts[1] !== '00' ? ('.' + parts[1]) : '';

    return dollars + cents;
}

function currencySymbol() {
    return document.getElementById('recently-viewed-container').dataset.currencySymbol;
}

function getProductURL(handler) {
    let rootDomain = window.location.origin;
    return `${rootDomain}/products/${handler}`;
}

//////////////////////////////////////////////////

let productObject = null;

if (productData) {
    productObject = {
        ...productData,
        compare_at_price_with_currency: currencySymbol() + formatPrice(productData.compare_at_price),
        price: currencySymbol() + formatPrice(productData.price),
        on_sale: productData.compare_at_price !== null && productData.compare_at_price > productData.price
    };
}



const updateRecentlyViewed = () => {
    if (recentlyViewed?.length > 0) {
        recentlyViewed.reverse();
        const productIds = recentlyViewed.map(product => product.id);

        if (productObject) {
            viewed_products = recentlyViewed.filter(product => product.id !== productObject.id).slice(0, max_results - 1);
        } else {
            viewed_products = recentlyViewed.slice(0, max_results - 1);
        }

        if (productObject && !productIds.includes(productObject.id)) {
            let newArray = recentlyViewed.reverse();
            newArray.push(productObject);
            const startingIndex = newArray.length > max_results ? newArray.length - max_results : 0;
            localStorage.setItem('recentlyViewedProducts', JSON.stringify(newArray.slice(startingIndex, newArray.length)));
        }
    } else if (productObject) {
        localStorage.setItem('recentlyViewedProducts', JSON.stringify([productObject]));
    }
};

updateRecentlyViewed();
